var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box is-main-box"},[_c('p',{staticClass:"subtitle is-5 is-message"},[_vm._v("Ajude o Centro Social Paroquial da Brandoa sem custo, através da consignação do seu IRS")]),_c('img',{staticClass:"is-picture",attrs:{"src":require("@/assets/Consignacao.png"),"alt":"Consignação IRS"}})])])
}]

export { render, staticRenderFns }